<div class="input-pair">
  <sh-select
    [options]="operatorOptions"
    optionLabel="label"
    optionValue="value"
    placeholder="shared.terms.select"
    ariaLabel="reports.customdata.filterCriteria"
    [value]="operator"
    (valueChange)="setOperator($event)"
  ></sh-select>
  <ng-container *ngIf="hasValue">
    <sh-input
      ariaLabel="shared.terms.value"
      [value]="value1"
      (valueChange)="setValue1($event)"
    ></sh-input>
    <ng-container *ngIf="isBetween">
      <span class="meta">{{ 'shared.terms.and' | translate }}</span>
      <sh-input
        ariaLabel="shared.terms.value"
        [value]="value2"
        (valueChange)="setValue2($event)"
      ></sh-input>
    </ng-container>
  </ng-container>
</div>
